import { useEffect, useRef, useState, type ReactElement } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { api, ApiError } from "../api/client";
import { AuthShell } from "../components/AuthShell";

type Status = "verifying" | "ok" | "error";

export function VerifyEmail(): ReactElement {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState<Status>("verifying");
  const [message, setMessage] = useState("Verifying your email…");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // guard StrictMode double-invoke
    ran.current = true;
    if (!token) {
      setStatus("error");
      setMessage("This verification link is missing its token.");
      return;
    }
    void (async () => {
      try {
        await api<{ detail: string }>("POST", "/auth/verify-email", { json: { token }, auth: false });
        setStatus("ok");
        setMessage("Your email is verified. You can sign in now.");
      } catch (err) {
        setStatus("error");
        setMessage(
          err instanceof ApiError ? err.message : "We couldn't verify this link. It may have expired.",
        );
      }
    })();
  }, [token]);

  return (
    <AuthShell title="Email verification" subtitle="Confirming your address.">
      <p className={status === "error" ? "form-error" : "muted"}>{message}</p>
      {status !== "verifying" ? (
        <p className="auth-alt">
          <Link to="/login">Continue to sign in</Link>
        </p>
      ) : null}
    </AuthShell>
  );
}
